import { MonthZeroBased } from '@deltasierra/shared';
import * as React from 'react';
import { CalendarContext } from './Calendar.context';
import { CalendarMonth } from './CalendarMonth';
import { useCalendarDays } from './CalendarMonth/use-calendar-days';
import { useDatesInCalendarMonth } from './CalendarMonth/use-dates-in-calendar-month';
import { useCurrentMonth } from './use-current-month';

export interface CalendarProps {
    children?: React.ReactNode;
    currentMonth?: MonthZeroBased;
    currentYear?: number;
    isSelectingTo?: boolean;
    onDecrementMonth?: () => void;
    onIncrementMonth?: () => void;
    onSelectDate?: (date?: Date) => void;
    selected?: Date;
    selectedTo?: Date;
    setSelected?: (selected?: Date) => void;
    setSelectedTo?: (selectedTo?: Date) => void;
}

export function Calendar(props: CalendarProps): JSX.Element {
    const { createShiftCurrentMonth, currentMonth, currentYear } = useCurrentMonth(props.selected, props.selectedTo);
    const superMonth = props.currentMonth ?? currentMonth;
    const superYear = props.currentYear ?? currentYear;
    const dates = useDatesInCalendarMonth(superYear, superMonth);
    const [hoveredDate, setHoveredDate] = React.useState<Date | undefined>(undefined);
    const days = useCalendarDays(dates, new Date(superYear, superMonth), {
        hovered: hoveredDate,
        isSelectingTo: props.isSelectingTo,
        selected: props.selected,
        selectedTo: props.selectedTo,
    });
    return (
        <CalendarContext.Provider
            value={{
                days,
                decrementMonth: props.onDecrementMonth ?? createShiftCurrentMonth(-1),
                displayMonth: superMonth,
                displayYear: superYear,
                hoveredDate,
                incrementMonth: props.onIncrementMonth ?? createShiftCurrentMonth(1),
                isSelectingTo: props.isSelectingTo,
                onSelectDate: props.onSelectDate,
                selected: props.selected,
                selectedTo: props.selectedTo,
                setHoveredDate,
                setSelected: props.setSelected,
                setSelectedTo: props.setSelectedTo,
            }}
        >
            {props.children}
        </CalendarContext.Provider>
    );
}
Calendar.displayName = 'Calendar';
Calendar.Month = CalendarMonth;
Calendar.MonthHeader = CalendarMonth.Header;
